import React from 'react';

export const ArrowBack = ({ className }: { className?: string }) => (
  <svg className={className} width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 1L1 12L17 23" stroke="currentColor" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
